import Instagram from "./Instagram"
const InstagramConfig = {
    settings: {
        layout: {},
    },
    routes: [
        {
            path: 'integration/instagram',
            element: <Instagram />,
        },
    ],
}

export default InstagramConfig